<script>
	import { beforeUpdate, afterUpdate, onMount } from 'svelte';
	import { db, live, next_session, auth, user, hashtag, break_session } from './stores.js';
	import Work from './Work.svelte';
	import Break from './Break.svelte';
	import Haco from './Haco.svelte';
	import GuestDashboard from './GuestDashboard.svelte';
	import SignIn from './components/SignIn.svelte';

	// export let name;
	let mode;
	let initialLoad = true;
	let inHaco = false;
	let hacoId;
	let timer;
	let next_cypher;

	let showSignIn = false;

	let invitedList;
	$: isInvited = invitedList && $user ? invitedList.includes($user.uid): false; 


	beforeUpdate(() => {
		if (initialLoad){
			console.log('beforeUpdate!', window.location);
			const pathname = window.location.pathname;
			if (pathname.includes("/haco/")){
				inHaco = true;
				hacoId = pathname.split("haco/")[1];
			}
			initialLoad = false;
		}
		// console.log("before update",$next_session);
		// if (timer) {
		// 	timer.restart(next_session);
		// }

	});

	// afterUpdate(() => {
	// 	console.log("$user: ", $user);

	// 	// console.log("after update");
	// 	// if (timer) {
    //     //     timer.restart(next_cypher);
    //     // }
	// });

	onMount(async () => {
		$db.collection("data").doc("status")
			.onSnapshot((doc) => {
				console.log("current data!: ", doc.data());
				mode = doc.data().session_mode;
				// live.set(doc.data().live_test); // For testing
				live.set(doc.data().live); // For real!!
				next_session.set(doc.data().next_session);
				next_cypher = doc.data().upcoming.sort((a,b)=>a-b)[0];
				hashtag.set(doc.data().hashtag);
				invitedList = doc.data().invited;
				if(doc.data().break_session){
					break_session.set(doc.data().break_session);
				}
				// if ($user){
				// 	isInvited = doc.data().invited.includes($user.uid);
				// 	console.log("isInvited: ", isInvited);
				// }

				// timer.restart($next_session);
			});

		// Check for banned updates
		$db.collection("banned").doc("users")
			.onSnapshot((doc) => {
				console.log("banned current data!: ", doc.data());
				if ($user){
					const isBanned = doc.data().ids.includes($user.uid);
					console.log("updating isBanned: ", isBanned);
					$user = {...$user, isBanned};
				}
			});

	});

    async function checkIfBanned(id){
        // Check to see if email is in approved list. If comes back empty, not allowed.
        const query =  await $db.collection("banned").where("ids","array-contains",id).get();
        return !query.empty;

    }

	$auth.onAuthStateChanged(async (userAuthState) => {
		if(userAuthState){
			console.log('onAuthStateChanged user: ',userAuthState);
			// // check if user is banned
			// const isBanned = await checkIfBanned(userAuthState.uid);
	        // console.log('isBanned: ', isBanned);
			// user.set({...$user,...userAuthState, isBanned});

			$db.collection("users").doc(userAuthState.uid)
			.onSnapshot((doc) => {
				// console.log("user info!: ", doc.data());
				user.set({...$user,...userAuthState,...doc.data()});
				console.log('user: ', $user);
			});

			showSignIn = false;

		} else {
			console.log('onAuthStateChanged no user');
			$user = null;
		};
	});

	function handleLaunchHACO(event) {
		console.log("handleLaunchHACO");
		hacoId = event.detail.id;
		inHaco = true;
	}

	function closeHaco() {
		inHaco = false;
		hacoId = "";
	}

	function logout() {
		$db.collection("users").doc($user.uid).set({
			isLoggedIn: false
		}, {merge: true}).then(() => {
			console.log("User profile successfully updated!");
			$auth.signOut();
			return true;
		}).catch((error) => {
			console.error("Error saving user profile: ", error);
		});
	}

	function handleCloseGuest(event) {
		// // remove from invitedList and save back to database
		// const updatedInvitedList = invitedList.filter(invited => invited !== $user.uid);
		// console.log("updatedInvitedList: ", updatedInvitedList);
		// $db.collection("data").doc("status").set({
		// 	invited: updatedInvitedList
		// }, {merge: true}).then(() => {
		// 	console.log("Invited list successfully updated!");
		// }).catch((error) => {
		// 	console.error("Error updating invited list: ",error);
		// })
		// // isInvited = false;
		$db.collection("users").doc($user.uid).set({
			isInvited: false
		}, {merge: true}).then(() => {
			console.log("Successfully declined invite");
		}).catch((error) => {
			console.error("Error declining invite: ",error);
		});

	}



</script>


<main>
	<nav>
		<a href="https://untilit.works">home</a>
		<a href="https://untilit.works/shop">shop</a>
		<a href="https://notify.untilit.works">subscribe</a>
		{#if $user}
			<span id="logout" on:click={logout}>logout</span>
		{:else}
			<span id="logout" on:click={ () => showSignIn = true }>login</span>
		{/if}
	</nav>
	<section>
		{#if showSignIn}
			<div id="modal">
				<div>
					<button id="closeModal" on:click={ () => showSignIn = false }>close</button>
					Log in to use certain features.
					<SignIn />	
				</div>
			</div>
		{/if}
		{#if $live}
			{#if $user && $user.isInvited}
				<GuestDashboard on:declined={handleCloseGuest} on:close={handleCloseGuest}/>
			{:else}
				{#if mode === "work"}
					{#if inHaco}
						<button id="closeHaco" on:click={closeHaco}>leave</button>
						<Haco id={hacoId} on:closeHaco={closeHaco}/>
					{:else}
						<Work on:launchHACO={handleLaunchHACO} />
					{/if}
				{:else if mode === "break"}
					<Break />
				{:else}
					<div class="welcome"><h1>Welcome to the cypher</h1></div>
				{/if}
			{/if}
		{:else}
			<div class="welcome">
				<div>
					<h1>Next LIVE cypher</h1>
					{#if next_cypher}
						<dwane-timer bind:this={timer} timer-deadline={next_cypher} countdown-start="3600000"></dwane-timer>
						<br/><a class="button" href="https://notify.untilit.works">get notified</a>
					{/if}	
				</div>
			</div>
		{/if}
	</section>

</main>

<style>
	main {
		text-align: center;
		/* padding: 1em;
		max-width: 240px;
		margin: 0 auto; */
	}

	section {
		height: calc(100vh - 52px);
		position: relative;
	}

	.welcome {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 100%;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4em;
		font-weight: 100;
		margin: 10px 0;
	}

	dwane-timer {
        --dwane-timer-font-family: "Roboto Mono";
        --dwane-timer-weekday-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-date-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-time-font-size: clamp(1.5rem, 1.5vw, 2rem);
        --dwane-timer-countdown-font-size: clamp(5rem, 1.5vw, 9rem);
        opacity: 0;
        transition:opacity 0.4s ease-in;
    }
    dwane-timer:defined {
        opacity: 1;
    }

	.button {
		color: black;
		padding: 15px;
		border-radius: 5px;
		background: white;
		border: 2px solid rgb(255,62,0);
		cursor: pointer;
		font-size: large;
		font-weight: bold;
		text-decoration: none;
		display: inline-block;
	}

	nav span {
		cursor: pointer;
	}

    #modal {
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100vw;
        background-color: white;
        z-index: 10;
		display: flex;
		justify-content: center;
		align-items: center;
    }
    #closeModal {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 10;
    }

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}

	#closeHaco {
		position: absolute;
		right: 10px;
		top: 10px;
	}

	button {
		cursor: pointer;
	}
</style>